import React from 'react'
import { withRouter } from 'react-router-dom'
import ServiceFormAPI from './ServiceFormAPI'

export default withRouter(({ match, history, location }) => {
  return (
    <div className="container">
      <ServiceFormAPI
        loadServiceTxn={
          location.state ? location.state.loadServiceTxn : undefined
        }
        initialSearchArchived={
          location.state ? location.state.searchArchived : false
        }
      />
    </div>
  )
})
